import BidprojectService from '../bid-project-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  mixins: [purchaseProjectStatus],
  data() {
    return {
      tabList: [], // tab集合
      tabActiveType: 2,
      total: 0,
      tableList: [],
      status: '',
      searchForm: {
        projectName: '', // 项目名称
        pageNum: 1,
        pageSize: 10,
        bidMode: '', // 竞价方式
        status: '', // 竞价状态
        type: 2 // 1转让，2采购
      },
      bidModeArr: [], // 竞价方式集合
      bidStatusArr: [
        {code: '', value: '全部'},
        {code: '42', value: '未开始'},
        {code: '60', value: '竞价中'},
        {code: '70', value: '已结束'}
      ] // 竞价状态
    };
  },
  created() {
    // 获取tab按钮字典
    const obj = {
      PROJECT_CATEGORY: 'tabList', // tab切换
      BIDDING_METHOD: 'bidModeArr' // 竞价方式
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
        this.bidModeArr = [{value: '全部', code: ''}, ...res.data];
      });
    });
    this.getBidProjectList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    changeTabIndex(type) {
      this.tabActiveType = type;
      this.searchForm.type = type;
      this.getBidProjectList();
    },
    // 打开竞价列表页面
    openBidPage() {
      window.open('https://bid.ejy365.com/board/boardListStaticGX?org=1af1306bff1511ea9c8d005056b7136c');
    },
    // 获取竞价列表
    getBidProjectList(page){
      if (page && page.pageNo && page.pageSize) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = this.searchForm.pageNum;
        this.searchForm.pageSize = this.searchForm.pageSize;
      }
      const obj = {};
      Object.keys(this.searchForm).forEach((key) => {
        if (key === 'status' && (this.searchForm.status === '' || !this.searchForm[key].length)) {
          obj.status = this.bidStatusArr.map(key => key.code);
        } else if(this.searchForm[key] && (this.searchForm[key] !== 'all')){
          if(key === 'status') {
            obj.status = [this.searchForm.status];
          } else {
            obj[key] = this.searchForm[key];
          }
        }
      });
      BidprojectService.getBidselectList(obj).then(res => {
        if (res && res.code === '0' && res.data) {
          this.total = res.data.total;
          this.tableList = res.data.list;
          this.tableList.forEach(item => {
            if(item.status > 60) {
              item.status = 70; // 已结束 从字段查找中文
            }
            if(item.status === 60) {
              item.status = 60; // 竞价中
            }
          });
        } else {
          this.tableList = [];
          this.total = 0;
        }
      });
    },
    clear () {
      this.searchForm = {
        type: this.searchForm.type,
        pageNum: 1,
        pageSize: 5,
        bidMode: '',
        projectName: '',
        status: ''
      };
      this.getBidProjectList();
    },
    goToSignUpDetail (obj) {
      BidprojectService.getEjyToken(obj.bidId).then(res => {
        if (res && res.code === '0' && res.data) {
          window.open(res.data);
          console.log(res.data, 'res.data.token');
        }
      }).catch((res) => {
        if(res.data.code !== '999') {
          this.$confirm('您还没报名该项目，请先报名后再竞价', '提示', {
            confirmButtonText: '立即报名',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.submit();
            if(this.tabActiveType === 1) {
              this.$router.push('/transaction-pro/detail?id=' + obj.projectId);
            } else {
              this.$router.push('/collective-purchasing/detail?id=' + obj.projectId);
            }
          }).catch(() => {
          });
        }
      });
    }
    // handdle (row, event, column) {
    //   console.log(row, event, column);
    //   this.$router.push('/notice-modular/detail?id=' + row.bidId + '&time=' + row.transactionAnnouncementTime + '&type=' + this.tabActiveType);
    // }
  }
};
